import type {SerializedStyles} from '@emotion/react';

import {css, useTheme} from '@emotion/react';
import styled from '@emotion/styled';
import {forwardRef, useEffect, useState} from 'react';

type Props = React.PropsWithChildren<{
  stickyOffset: number;
  injectedStyles?: SerializedStyles;
  className?: string;
  name?: string;
}>;

export const Sticky = styled(
  forwardRef<HTMLDivElement, Props>(function StickyComponent(
    {children, className, stickyOffset, injectedStyles, name = 'other'},
    ref
  ) {
    const [isSticky, setIsSticky] = useState(false);
    const theme = useTheme();

    useEffect(() => {
      const handleScroll = () => {
        // @ts-expect-error: TS2339
        const top = Math.round(ref?.current?.getBoundingClientRect().top ?? 0);

        if (top <= stickyOffset) {
          setIsSticky(true);
        } else {
          setIsSticky(false);
        }
      };
      window.addEventListener('scroll', handleScroll);

      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, [ref, stickyOffset]);

    return (
      <div
        id={name}
        ref={ref}
        className={className}
        css={isSticky ? [theme.elevations.large, injectedStyles] : undefined}
        data-sticky={isSticky ? true : undefined}
      >
        {children}
      </div>
    );
  })
)<Props>(
  ({theme, stickyOffset}) => css`
    position: sticky;
    top: ${stickyOffset}px;
    z-index: 2;
    transition: box-shadow 0.2s ease-in-out;

    ${theme.respondTo(
      'lg',
      css`
        &::before {
          height: 20px;
        }
      `
    )}
  `
);
